import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  image: {
    width: '100%',
    height: 'auto'
  },
  paragraph: {
    whiteSpace: 'pre-line',
    margin: 0
  },
  title: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    fontWeight: 500
  },
  subtitle: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3),
    fontWeight: 300
  },
}));

export default (props) => {
  const classes = useStyles();
  return (
    <>
    <h2 className={classes.title}>{props.config.title}</h2>
    <Grid container direction="row" alignItems="flex-start" spacing={6}>
      <Grid item xs={12} sm={4}>
        <img src={props.config.imageUrl} alt={props.config.imageAlt} className={classes.image} />
      </Grid>
      <Grid item xs={12} sm={8}>
        <p className={classes.paragraph}>{props.config.description}</p>
      </Grid>
    </Grid>
    </>
  );
}